<script>
  import {createEventDispatcher, onMount, onDestroy} from 'svelte';
  import {fade} from 'svelte/transition';

  const dispatch = createEventDispatcher();

  let className = '';
  export {className as class};
  export let style = '';

  onMount(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = '6px';
  });
  onDestroy(() => {
    document.body.style.overflow = 'initial';
    document.body.style.paddingRight = 'unset';
  });

  function handleClickMask() {
    dispatch('maskClick');
  }

  function handleClickModel(e) {
    e.stopPropagation();
  }
</script>

<style>
  .modal-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 7000;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }
  .modal {
    position: relative;
    border: 1px solid var(--B0);
    border-radius: 12px;
    padding: 0;
    width: calc(100vw - 4em);
    max-width: 32em;
    max-height: calc(100vh - 4em);
    background: var(--B2);
    overflow: auto;
    box-shadow: 0 0 20px #888;
  }
  :global(.dark) .modal {
    box-shadow: 0 0 20px #070f15;
  }
</style>

<div class={className}>
  <div class="modal-mask" on:click={handleClickMask} in:fade={{duration: 100}} out:fade={{duration: 100}}>
    <div class="modal sv B3" {style} on:click={handleClickModel}>
      <slot name="header" />
      <slot />
      <slot name="footer" />
    </div>
  </div>
</div>
